import { createSlice } from '@reduxjs/toolkit';

import { LOADING_STATE } from '../constants/loadingState';

const companiesSlice = createSlice({
  name: 'companies',

  initialState: {
    supplierAlertConfigs: [],
    supplierAlertConfigsLoading: LOADING_STATE.NOT_LOADED,
  },

  reducers: (create) => ({
    replaceSupplierAlertConfigs: create.reducer((state, parameter) => {
      const { payload } = parameter;

      state.supplierAlertConfigs = [...payload];
      state.supplierAlertConfigsLoading = LOADING_STATE.SUCCEEDED;
    }),

    setSupplierAlertConfigsLoading: create.reducer((state, parameter) => {
      const { payload } = parameter;

      state.supplierAlertConfigsLoading = payload;
    }),
  }),
});

const { actions, reducer } = companiesSlice;
export const { replaceSupplierAlertConfigs, setSupplierAlertConfigsLoading } =
  actions;
export default reducer;
